var collapsible_list_pair_default = {
  "container": "eIfc0",
  "title": "MySEC",
  "viewerContainer": "sWupV",
  "titleContainer": "nxgAL",
  "expandIcon": "J4RrT",
  "dndIcon": "VxD9k",
  "RTL": "m2j56",
  "LTR": "f30UA",
  "itemContainer": "UYzvf",
  "itemContainerViewer": "_1laCv",
  "mouseDown": "_7olA5",
  "innerEditor": "cO7Mp",
  "item": "lRyzc",
  "floatingAddPluginMenuWrapper": "S9oBU",
  "childrenHidden": "_4EjJX"
};
export {
  collapsible_list_pair_default as default
};
//# sourceMappingURL=collapsible-list-pair-scss.js.map
